import { call, delay, put, putResolve, select, takeEvery, takeLatest } from 'typed-redux-saga/macro';
import { clearOnboardingHistory } from 'features/wealth/utils/onboardingHistory';
import { getConnectedAccount } from 'actions/invest';
import { LOGGED_OUT } from 'actions/types';
import { getAllPotsActivities, getPots, getPotsAccount, getPotsAccountWithRetry, } from '../actions';
function* getPotsWorker(action) {
    const status = action.payload?.account?.status;
    if (status && status !== 'NOT_STARTED') {
        yield* put(getPots());
    }
    // Used to show the initial deposit in Pots
    if (status === 'ACTIVE' && !action.payload?.hasFundedPot) {
        // Two items are enough to tell whether the deposit is the only activity
        yield* put(getAllPotsActivities({ page: 1, perPage: 2 }));
    }
}
function* getPotsWorkerWithoutCheckWorker() {
    yield* put(getPots());
}
function* getPotsAccountWithRetryWorker(action) {
    yield* putResolve(getPotsAccount());
    yield* putResolve(getConnectedAccount());
    const potsAccount = yield* select((store) => store.pots.account);
    if (potsAccount?.status === 'OPENING_IN_PROGRESS' || potsAccount?.status === 'KYC_PENDING') {
        const { retryTimes } = action;
        if (retryTimes) {
            yield* delay(5 * 1000);
            yield* put(getPotsAccountWithRetry(retryTimes - 1));
        }
    }
}
function* clearPotsOnboardingHistoryWorker() {
    yield* call(clearOnboardingHistory, 'pots');
}
function* potsSagas() {
    yield* takeEvery(['CLEAR_POTS_ONBOARDING_STATE', LOGGED_OUT], clearPotsOnboardingHistoryWorker);
    yield* takeLatest('GET_POTS_ACCOUNT_SUCCESS', getPotsWorker);
    yield* takeLatest('CREATE_POTS_ACCOUNT_SUCCESS', getPotsWorkerWithoutCheckWorker);
    yield* takeLatest('GET_POTS_ACCOUNT_WITH_RETRY', getPotsAccountWithRetryWorker);
}
export default potsSagas;
